module.exports = __webpack_public_path__ + "static/img/icon_pro3s.5d02cd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_pro3s.png
// module id = 8VpJ
// module chunks = 11